import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { toast } from "sonner";
import { Save } from "lucide-react";

const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1.5">{label}</label>
    {children}
  </div>
);

export default function CreatePayment() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", type: "Bank", account_details: "", status: "active" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/payment-methods", form);
      toast.success("Payment method created");
      navigate("/payment/list");
    } catch (err) {
      toast.error("Failed to create");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="create-payment-page">
      <PageHeader title="Create Payment" subtitle="Add a new payment method for deposits and withdrawals" />
      <form onSubmit={submit} className="bg-white border border-gray-200 rounded-sm p-6 max-w-2xl" data-testid="create-payment-form">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Name">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="create-payment-name" />
          </Field>
          <Field label="Type">
            <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="create-payment-type">
              <option>Bank</option>
              <option>Crypto</option>
              <option>Card</option>
              <option>Wallet</option>
            </select>
          </Field>
          <Field label="Account Details">
            <input value={form.account_details} onChange={(e) => setForm({ ...form, account_details: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm" data-testid="create-payment-account" />
          </Field>
          <Field label="Status">
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className="w-full h-10 px-3 border border-gray-200 rounded-sm text-sm">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </Field>
        </div>
        <div className="flex justify-end gap-2 mt-6 pt-5 border-t border-gray-100">
          <button type="button" onClick={() => navigate("/payment/list")} className="h-10 px-4 border border-gray-200 rounded-sm text-sm">Cancel</button>
          <button type="submit" disabled={loading} className="h-10 px-5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50" data-testid="create-payment-submit">
            <Save size={14} /> {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
